// New solution product pages — same shape as mockData products
const IMG = 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images';
const img = {
  wtp: `${IMG}/c0252d8d1c66f7574fc972f359f7fc489c0929e53c862e004029bb5dd7e5e832.jpeg`,
  stp: `${IMG}/d750a12e48ec7e73d58f32a410bf3dfe8e021fd747d2554eb9a3537cdf4f8b5f.jpeg`,
  etp: `${IMG}/70b8b01a0633bf3a7a68a30c9b649d354ca7eee4b94779bc0096d81156f18ce2.jpeg`,
  zld: `${IMG}/95e71057c578b4127dd24a588faf07e8926fba427083f2c7167690b550cd64d6.jpeg`,
  unscrambler: `${IMG}/d1543bed77798005122445da678fc0a52ff09692fb06cf3839819a6fb845df86.jpeg`,
  coding: `${IMG}/7ba7d48657178d6a9fa0f86d926762d0e16577076e6bbc44e795744edc128d35.jpeg`,
  carton: `${IMG}/1f3f43d28fc43eb385e97568ddd4c637cfdcc44058b3336455c17caf3a268d06.jpeg`,
  juice: `${IMG}/e76c7ebfecab6c405a0f34d4d269ca616fac15db37ea70d5ebf0ccc0d45384c6.jpeg`,
  csd: `${IMG}/ddcdae7798bddde062aa744694121c01dcab07e289e61f63478a913773df29b9.jpeg`,
  compressor: `${IMG}/c606d4001aebde900979bb2758694c57b33317ddf2e2b88a68b4a077e5612d45.jpeg`,
  filling: `${IMG}/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg`,
  conveyor: `${IMG}/dbde2cca544a6c11e7bd1116760c2ac46cfbe90f3366f651e1e1999e9b1c409f.jpeg`,
  factory: `${IMG}/fee152e3e8af8f2f2db9442eb1155451bdd1947137f5ca671d324b946f16f322.jpeg`,
  lab: `${IMG}/b7c7fd0e3e1392a2285249164a8dbdbb0010dcc289d8cf17785c807d41753619.jpeg`
};

const BROCHURE = '/downloads/alden-product-brochure.pdf';

export const waterTreatmentProducts = [
  {
    id: 'wt-wtp', capacity: '10 KLD – 5 MLD', title: 'Water Treatment Plant (WTP)', slug: 'water-treatment-plant',
    metaTitle: 'Water Treatment Plant Manufacturer in India | WTP 10 KLD – 5 MLD | Alden Technologies',
    metaDescription: 'Alden Technologies manufactures customized Water Treatment Plants (WTP) from 10 KLD to 5 MLD — filtration, softening, clarification and disinfection systems with PAN India installation. Get a free quotation.',
    heroImage: img.wtp,
    price: { range: '₹5 – 50 Lakhs', investment: 'Capacity & Water Analysis Based' },
    specifications: {
      capacity: '10 KLD to 5 MLD (customized)', process: 'Clarification, Filtration, Softening, Disinfection',
      filters: 'Pressure Sand Filter, Activated Carbon Filter', material: 'MSEP / FRP / SS 304 vessels',
      automation: 'Manual / Semi-Auto / PLC Automatic', application: 'Drinking, Process & Utility Water'
    },
    features: [
      'Custom process design based on raw water analysis', 'Multi-grade sand and activated carbon filtration',
      'Softener and demineralization options', 'Chemical dosing systems with metering pumps',
      'UV and chlorination disinfection', 'Skid-mounted or civil construction options',
      'PLC automation with instrumentation', 'In-house fabricated vessels and piping'
    ],
    applications: ['Packaged Drinking Water Plants', 'Hotels, Hospitals & Institutions', 'Industrial Process Water', 'Residential Townships', 'Food & Beverage Industry'],
    idealFor: 'Industries, institutions and bottling plants that need reliable treated water matched to their raw water quality and end use.',
    technicalDetails: { dimensions: 'Custom per capacity', weight: 'Custom', voltage: '415V / 3 Phase', warranty: '1 Year Comprehensive' },
    gallery: [img.wtp, img.factory, img.lab], brochureUrl: BROCHURE
  },
  {
    id: 'wt-stp', capacity: '5 KLD – 2 MLD', title: 'Sewage Treatment Plant (STP)', slug: 'sewage-treatment-plant',
    metaTitle: 'STP Plant Manufacturer in India | Sewage Treatment Plant 5 KLD – 2 MLD | Alden Technologies',
    metaDescription: 'MBBR, SBR and MBR based Sewage Treatment Plants (STP) from 5 KLD to 2 MLD by Alden Technologies. Compact, odour-free, pollution-board compliant designs with PAN India installation.',
    heroImage: img.stp,
    price: { range: '₹8 – 60 Lakhs', investment: 'Technology & Capacity Based' },
    specifications: {
      capacity: '5 KLD to 2 MLD', technology: 'MBBR / SBR / MBR / Extended Aeration',
      treatedWater: 'Reusable for flushing, gardening, cooling', material: 'Civil / MSEP / FRP construction',
      automation: 'Semi-Auto / PLC Automatic', compliance: 'CPCB / SPCB discharge norms'
    },
    features: [
      'MBBR/SBR/MBR technology options', 'Compact footprint, low odour design',
      'Treated water reuse for flushing and gardening', 'Energy-efficient air blowers and diffusers',
      'Sludge handling with filter press options', 'PLC automation with level and flow control',
      'Designed to state pollution board norms', 'AMC and operation support available'
    ],
    applications: ['Residential Societies & Townships', 'Hotels & Hospitals', 'Industrial Campuses', 'Commercial Buildings & Malls', 'Educational Institutions'],
    idealFor: 'Builders, institutions and industries required to treat sewage on-site and reuse treated water under pollution board norms.',
    technicalDetails: { dimensions: 'Custom per capacity', weight: 'Custom', voltage: '415V / 3 Phase', warranty: '1 Year Comprehensive' },
    gallery: [img.stp, img.etp, img.factory], brochureUrl: BROCHURE
  },
  {
    id: 'wt-etp', capacity: '5 KLD – 2 MLD', title: 'Effluent Treatment Plant (ETP)', slug: 'effluent-treatment-plant',
    metaTitle: 'ETP Plant Manufacturer in India | Effluent Treatment Plant | Alden Technologies',
    metaDescription: 'Industrial Effluent Treatment Plants (ETP) designed for textile, food, pharma and chemical effluents. Physico-chemical + biological treatment, pollution board compliant. PAN India by Alden Technologies.',
    heroImage: img.etp,
    price: { range: '₹10 – 75 Lakhs', investment: 'Effluent Load Based' },
    specifications: {
      capacity: '5 KLD to 2 MLD', process: 'Physico-chemical + Biological + Tertiary',
      stages: 'Equalization, Coagulation, Aeration, Clarification, Filtration', sludge: 'Filter Press / Decanter',
      automation: 'Semi-Auto / PLC Automatic', compliance: 'CPCB / SPCB discharge norms'
    },
    features: [
      'Effluent characterization based process design', 'Chemical dosing and flocculation systems',
      'Biological treatment with MBBR/activated sludge', 'Tertiary filtration for reuse standards',
      'Filter press based sludge dewatering', 'Corrosion-resistant construction options',
      'Online monitoring provisions (pH, flow, TSS)', 'Operation & maintenance contracts available'
    ],
    applications: ['Textile & Dyeing Units', 'Food & Beverage Industry', 'Pharmaceutical Plants', 'Chemical & Process Industries', 'Automobile & Engineering Units'],
    idealFor: 'Manufacturing industries that must treat process effluent to pollution board discharge or reuse standards.',
    technicalDetails: { dimensions: 'Custom per capacity', weight: 'Custom', voltage: '415V / 3 Phase', warranty: '1 Year Comprehensive' },
    gallery: [img.etp, img.stp, img.factory], brochureUrl: BROCHURE
  },
  {
    id: 'wt-mbr', capacity: '10 KLD – 1 MLD', title: 'MBR Plant (Membrane Bioreactor)', slug: 'mbr-plant',
    metaTitle: 'MBR Plant Manufacturer | Membrane Bioreactor STP/ETP | Alden Technologies',
    metaDescription: 'Membrane Bioreactor (MBR) plants delivering superior treated water quality in a compact footprint — ideal for reuse applications and space-constrained sites. Design to commissioning by Alden Technologies.',
    heroImage: img.wtp,
    price: { range: '₹20 Lakhs – 1.5 Crore', investment: 'Premium Treatment Technology' },
    specifications: {
      capacity: '10 KLD to 1 MLD', membranes: 'Submerged hollow-fibre / flat-sheet UF',
      outputQuality: 'BOD <5, TSS <5 — reuse grade', footprint: '30-50% smaller than conventional',
      automation: 'Fully PLC Automatic', cleaning: 'Automated backwash & CIP'
    },
    features: [
      'Reuse-grade treated water without tertiary clarifiers', 'Compact footprint for space-constrained sites',
      'Consistent output regardless of load variation', 'Automated membrane backwash and CIP',
      'Lower sludge generation than conventional ASP', 'Modular capacity expansion',
      'Remote monitoring provisions', 'Suitable for STP and ETP applications'
    ],
    applications: ['High-Rise Buildings & Townships', 'Hotels & Hospitals with reuse mandates', 'Industries with water recycling targets', 'Malls & Commercial Complexes'],
    idealFor: 'Projects that need reuse-grade treated water or have strict space constraints where conventional STP/ETP cannot fit.',
    technicalDetails: { dimensions: 'Custom per capacity', weight: 'Custom', voltage: '415V / 3 Phase', warranty: '1 Year Comprehensive' },
    gallery: [img.wtp, img.stp, img.factory], brochureUrl: BROCHURE
  },
  {
    id: 'wt-zld', capacity: '10 KLD – 500 KLD', title: 'ZLD Plant (Zero Liquid Discharge)', slug: 'zld-plant',
    metaTitle: 'ZLD Plant Manufacturer in India | Zero Liquid Discharge Systems | Alden Technologies',
    metaDescription: 'Zero Liquid Discharge (ZLD) systems combining RO, Multiple Effect Evaporators and ATFD to achieve 100% liquid recovery for pollution-board mandated industries. Engineered by Alden Technologies.',
    heroImage: img.zld,
    price: { range: '₹50 Lakhs – 5 Crore', investment: 'Effluent Load & Recovery Based' },
    specifications: {
      capacity: '10 KLD to 500 KLD effluent', train: 'Pre-treatment + RO + MEE + ATFD',
      recovery: 'Up to 95-98% water recovery', residue: 'Dry salt / sludge for disposal',
      automation: 'Fully PLC / SCADA Automatic', compliance: 'CPCB ZLD mandates'
    },
    features: [
      'Complete ZLD train under single-point responsibility', 'High-recovery RO ahead of evaporation to cut opex',
      'Multiple Effect Evaporator with vapour recompression options', 'ATFD for final salt/solids drying',
      'Condensate recovery for reuse in process', 'Designed to CPCB/SPCB ZLD directives',
      'SCADA-based operation and reporting', 'Detailed water balance & opex projections provided'
    ],
    applications: ['Textile Dyeing & Processing', 'Pharmaceutical & API Units', 'Chemical & Pesticide Plants', 'Distilleries & Breweries', 'CETP Upgrades'],
    idealFor: 'Industries under ZLD mandates that must eliminate liquid discharge and recover maximum water for reuse.',
    technicalDetails: { dimensions: 'Custom per capacity', weight: 'Custom', voltage: '415V / 3 Phase', warranty: '1 Year Comprehensive' },
    gallery: [img.zld, img.etp, img.factory], brochureUrl: BROCHURE
  },
  {
    id: 'wt-mee', capacity: '5 KLD – 300 KLD', title: 'Multiple Effect Evaporator (MEE)', slug: 'multiple-effect-evaporator',
    metaTitle: 'Multiple Effect Evaporator (MEE) Manufacturer | Alden Technologies',
    metaDescription: 'Multiple Effect Evaporators for high-TDS effluent concentration — falling film and forced circulation designs with 2 to 5 effects, engineered for ZLD applications by Alden Technologies.',
    heroImage: img.zld,
    price: { range: '₹40 Lakhs – 3 Crore', investment: 'Evaporation Load Based' },
    specifications: {
      capacity: '5 KLD to 300 KLD evaporation', design: 'Falling Film / Forced Circulation',
      effects: '2 to 5 effects for steam economy', material: 'SS 316 / Duplex / as per effluent',
      heating: 'Steam / TVR / MVR options', automation: 'PLC / SCADA Automatic'
    },
    features: [
      'Falling film and forced circulation configurations', 'Multi-effect design for low steam consumption',
      'TVR/MVR options to further cut energy cost', 'Corrosion-appropriate metallurgy selection',
      'CIP arrangements for scaling control', 'Condensate polishing for reuse',
      'Integrates with ATFD for final solids', 'Performance guarantee runs at commissioning'
    ],
    applications: ['ZLD Systems', 'High-TDS RO Reject Concentration', 'Pharma & Chemical Concentration', 'Textile Brine Recovery', 'Distillery Spent Wash'],
    idealFor: 'Industries needing to concentrate high-TDS effluent or RO reject streams as part of ZLD or recovery systems.',
    technicalDetails: { dimensions: 'Custom per capacity', weight: 'Custom', voltage: '415V / 3 Phase', warranty: '1 Year Comprehensive' },
    gallery: [img.zld, img.factory, img.etp], brochureUrl: BROCHURE
  },
  {
    id: 'wt-atfd', capacity: '50 – 2000 kg/hr', title: 'ATFD (Agitated Thin Film Dryer)', slug: 'agitated-thin-film-dryer',
    metaTitle: 'ATFD Manufacturer | Agitated Thin Film Dryer for ZLD | Alden Technologies',
    metaDescription: 'Agitated Thin Film Dryers (ATFD) converting MEE concentrate into dry, handleable salt/solids — the final step of Zero Liquid Discharge. Engineered and fabricated by Alden Technologies.',
    heroImage: img.zld,
    price: { range: '₹25 Lakhs – 1.5 Crore', investment: 'Drying Load Based' },
    specifications: {
      capacity: '50 to 2000 kg/hr feed', product: 'Dry powder / flakes (5-10% moisture)',
      heating: 'Steam / Thermic Fluid jacket', material: 'SS 316 / as per salt chemistry',
      vacuum: 'Optional vacuum operation', automation: 'PLC controlled'
    },
    features: [
      'Converts MEE concentrate to dry conveyable solids', 'Thin-film design handles scaling & viscous slurries',
      'Steam or thermic fluid heating options', 'Vapour recovery back to condensate',
      'Metallurgy matched to salt chemistry', 'Continuous operation with low manpower',
      'Compact vertical/horizontal configurations', 'Integrated with ZLD control system'
    ],
    applications: ['ZLD Final Stage Drying', 'Mixed Salt Drying', 'Chemical & Pharma Slurries', 'Textile Brine Solids'],
    idealFor: 'ZLD installations that must convert evaporator concentrate into dry solids for safe disposal or recovery.',
    technicalDetails: { dimensions: 'Custom per capacity', weight: 'Custom', voltage: '415V / 3 Phase', warranty: '1 Year Comprehensive' },
    gallery: [img.zld, img.etp, img.factory], brochureUrl: BROCHURE
  }
];

export const bottlingMachineryProducts = [
  {
    id: 'bm-unscrambler', capacity: 'Up to 200 BPM', title: 'Automatic Bottle Unscrambler', slug: 'bottle-unscrambler',
    metaTitle: 'Bottle Unscrambler Manufacturer | Automatic PET Bottle Feeding | Alden Technologies',
    metaDescription: 'Automatic bottle unscramblers that orient and feed empty PET bottles to your filling line at up to 200 BPM — eliminate manual bottle feeding. Manufactured by Alden Technologies, Jaipur.',
    heroImage: img.unscrambler,
    price: { range: '₹6 – 18 Lakhs', investment: 'Speed & Bottle Range Based' },
    specifications: {
      capacity: 'Up to 200 BPM', bottleRange: '200 ml – 2000 ml PET',
      hopper: 'Bulk elevator with storage hopper', orientation: 'Rotary / centrifugal orientation',
      material: 'SS 304 contact parts', automation: 'PLC with speed sync to filler'
    },
    features: [
      'Eliminates 2-3 manual bottle feeding workers', 'Bulk hopper with elevator for continuous supply',
      'Gentle handling — no bottle scuffing', 'Quick changeover between bottle sizes',
      'Speed-synchronised with filling machine', 'Ionised air rinsing option before discharge',
      'SS 304 construction with safety guarding', 'Low maintenance rotary design'
    ],
    applications: ['Mineral Water Bottling Lines', 'Juice & CSD Lines', 'Edible Oil Filling Lines', 'Pharma & Chemical Bottling'],
    idealFor: 'Bottling lines of 60 BPM and above where manual bottle feeding limits speed and hygiene.',
    technicalDetails: { dimensions: 'Custom per speed', weight: '600-1500 kg', voltage: '415V / 3 Phase', warranty: '1 Year Comprehensive' },
    gallery: [img.unscrambler, img.conveyor, img.filling], brochureUrl: BROCHURE
  },
  {
    id: 'bm-conveyors', capacity: 'Custom Lengths', title: 'Conveyor Systems (Air, Slat & Packing)', slug: 'conveyor-systems',
    metaTitle: 'Bottling Conveyor Systems Manufacturer | Air, Slat & Packing Conveyors | Alden Technologies',
    metaDescription: 'Air conveyors, SS slat chain conveyors and packing conveyors that link blowing, filling, labelling and packaging into one synchronized bottling line. Fabricated in-house by Alden Technologies.',
    heroImage: img.conveyor,
    price: { range: '₹1.5 – 15 Lakhs', investment: 'Line Length Based' },
    specifications: {
      types: 'Air / Slat Chain / Packing / Roller', material: 'SS 304 frame & guides',
      speed: 'VFD-controlled, synced to line', chain: 'SS / Acetal slat chains',
      guides: 'Adjustable side guides for all sizes', automation: 'Line integration with sensors'
    },
    features: [
      'Air conveyors for empty PET bottle transfer', 'SS slat conveyors for filled bottle movement',
      'Accumulation tables to absorb line stoppages', 'VFD speed control synced with machines',
      'Adjustable guide rails for quick size change', 'Hygienic SS 304 construction',
      'Modular sections for easy expansion', 'In-house fabrication for custom layouts'
    ],
    applications: ['Complete Bottling Line Integration', 'Blower-to-Filler Air Conveying', 'Filler-to-Labeller-to-Packer Transfer', 'Case & Carton Packing Sections'],
    idealFor: 'Plants integrating multiple machines into one synchronized line, or expanding existing lines with accumulation and transfer sections.',
    technicalDetails: { dimensions: 'Custom per layout', weight: 'Per section', voltage: '415V / 3 Phase', warranty: '1 Year Comprehensive' },
    gallery: [img.conveyor, img.unscrambler, img.filling], brochureUrl: BROCHURE
  }
];

export const packagingMachineryProducts = [
  {
    id: 'pk-batchcoding', capacity: 'Up to 300 prints/min', title: 'Batch Coding Machine (Inkjet Printer)', slug: 'batch-coding-machine',
    metaTitle: 'Batch Coding Machine Manufacturer | Inkjet Date Coding for Bottles | Alden Technologies',
    metaDescription: 'Industrial inkjet batch coding machines printing MFG date, batch number and MRP on PET bottles, caps and cartons at line speed — FSSAI labelling compliant. Supplied & supported by Alden Technologies.',
    heroImage: img.coding,
    price: { range: '₹1.5 – 6 Lakhs', investment: 'Entry to High-Speed' },
    specifications: {
      technology: 'CIJ (Continuous Inkjet) / TIJ', speed: 'Up to 300 prints/minute',
      lines: '1-5 lines of print', characters: 'Date, batch, MRP, logo, QR/barcode',
      integration: 'Conveyor mounted with sensor', automation: 'Auto date/batch increment'
    },
    features: [
      'Prints MFG date, batch no., MRP as per FSSAI rules', 'CIJ technology for curved PET surfaces',
      'Auto date and batch increment', 'QR/barcode printing capability',
      'Quick-dry food-grade inks', 'Conveyor mounting with product sensor',
      'Low ink consumption per print', 'On-site installation and training included'
    ],
    applications: ['PET Bottle Coding', 'Cap & Lid Coding', 'Carton & Shrink Pack Coding', 'Pouch & Label Coding'],
    idealFor: 'Every packaged product line — FSSAI labelling rules make batch/date coding mandatory on all packaged water and beverages.',
    technicalDetails: { dimensions: 'Compact bench/stand mount', weight: '15-40 kg', voltage: '220V / Single Phase', warranty: '1 Year Comprehensive' },
    gallery: [img.coding, img.conveyor, img.filling], brochureUrl: BROCHURE
  },
  {
    id: 'pk-cartoning', capacity: '5 – 25 cases/min', title: 'Cartoning & Secondary Packaging Machine', slug: 'cartoning-secondary-packaging',
    metaTitle: 'Cartoning Machine Manufacturer | Secondary Packaging Solutions | Alden Technologies',
    metaDescription: 'Semi and fully automatic case packing, carton erecting, taping and secondary packaging machines for bottled water and beverage plants. Complete end-of-line solutions by Alden Technologies.',
    heroImage: img.carton,
    price: { range: '₹4 – 25 Lakhs', investment: 'Automation Level Based' },
    specifications: {
      capacity: '5 – 25 cases/minute', functions: 'Carton erecting, packing, taping, sealing',
      caseSizes: 'Adjustable for 12/15/24 bottle cases', material: 'MS powder coated / SS options',
      automation: 'Semi-Auto / Fully Automatic', integration: 'Inline with packing conveyor'
    },
    features: [
      'Carton erecting and bottom taping', 'Manual-assist or automatic bottle case packing',
      'Top taping and sealing station', 'Adjustable for multiple case sizes',
      'Inline integration with packing conveyors', 'Reduces end-of-line manpower by 3-4 workers',
      'Optional check-weigher integration', 'Compact end-of-line footprint'
    ],
    applications: ['Bottled Water Case Packing', 'Juice & CSD Secondary Packaging', 'Jar & Can Cartoning', 'E-commerce Ready Packaging'],
    idealFor: 'Plants dispatching in corrugated cases — hotels, institutional and e-commerce supply chains that demand carton packaging over shrink film.',
    technicalDetails: { dimensions: 'Custom per configuration', weight: '400-1200 kg', voltage: '415V / 3 Phase', warranty: '1 Year Comprehensive' },
    gallery: [img.carton, img.conveyor, img.factory], brochureUrl: BROCHURE
  }
];

export const beveragePlantProducts = [
  {
    id: 'bev-juice', capacity: '1,000 – 10,000 LPH', title: 'Juice Processing & Bottling Plant', slug: 'juice-plant',
    metaTitle: 'Juice Plant Manufacturer in India | Turnkey Juice Processing & Filling | Alden Technologies',
    metaDescription: 'Turnkey juice processing plants — extraction, pasteurization, homogenization and hot/aseptic filling lines for mango, mixed fruit and citrus beverages. Complete projects by Alden Technologies.',
    heroImage: img.juice,
    price: { range: '₹60 Lakhs – 5 Crore', investment: 'Capacity & Process Based' },
    specifications: {
      capacity: '1,000 – 10,000 LPH processing', process: 'Extraction, Pasteurization, Homogenization',
      filling: 'Hot fill / RGB / PET aseptic options', products: 'Mango, Mixed Fruit, Citrus, Nectars',
      material: 'SS 304/316 food-grade throughout', automation: 'PLC with recipe management'
    },
    features: [
      'Complete process line from fruit/pulp to packed bottle', 'Plate & tubular pasteurizers with hold tubes',
      'High-pressure homogenization for stability', 'Sugar syrup preparation and blending section',
      'Hot filling with bottle cooling tunnels', 'CIP system for hygienic operation',
      'FSSAI-compliant process documentation', 'Recipe-based PLC automation'
    ],
    applications: ['Mango & Mixed Fruit Drinks', 'Citrus & Lemon Beverages', 'Nectars & Fruit Pulp Based Drinks', 'Flavoured Water & Squash'],
    idealFor: 'Entrepreneurs and existing bottlers expanding into fruit beverages — one of the fastest-growing beverage categories in India.',
    technicalDetails: { dimensions: 'Custom per capacity', weight: 'Custom', voltage: '415V / 3 Phase', warranty: '1 Year Comprehensive' },
    gallery: [img.juice, img.filling, img.factory], brochureUrl: BROCHURE
  },
  {
    id: 'bev-csd', capacity: '30 – 200 BPM', title: 'CSD / Soft Drink Plant', slug: 'csd-soft-drink-plant',
    metaTitle: 'CSD Plant Manufacturer in India | Carbonated Soft Drink Bottling | Alden Technologies',
    metaDescription: 'Complete carbonated soft drink (CSD) plants — syrup room, carbonation, counter-pressure filling and packaging for cola, orange, lemon and soda brands. Turnkey execution by Alden Technologies.',
    heroImage: img.csd,
    price: { range: '₹80 Lakhs – 6 Crore', investment: 'Capacity & Automation Based' },
    specifications: {
      capacity: '30 – 200 BPM (PET)', carbonation: 'Inline carbonator with CO2 dosing',
      filling: 'Counter-pressure isobaric filling', syrupRoom: 'Sugar dissolution, blending, filtration',
      products: 'Cola, Orange, Lemon, Soda, Energy', automation: 'PLC with brix/carbonation control'
    },
    features: [
      'Complete syrup room with blending systems', 'Inline carbonation with precise CO2 control',
      'Counter-pressure filling for fizz retention', 'Chilling systems for carbonation efficiency',
      'Brix and carbonation monitoring instruments', 'Handles returnable glass & PET formats',
      'CIP system across syrup and filling sections', 'BIS/FSSAI documentation support'
    ],
    applications: ['Cola & Flavoured CSD Brands', 'Sparkling Water & Soda', 'Energy & Sports Drinks', 'Regional Soft Drink Franchises'],
    idealFor: 'Regional beverage brands and contract bottlers entering the high-margin carbonated drinks segment.',
    technicalDetails: { dimensions: 'Custom per capacity', weight: 'Custom', voltage: '415V / 3 Phase', warranty: '1 Year Comprehensive' },
    gallery: [img.csd, img.filling, img.conveyor], brochureUrl: BROCHURE
  }
];

export const bottleManufacturingProducts = [
  {
    id: 'bmf-compressor', capacity: '10 – 40 bar', title: 'High-Pressure Air Compressors', slug: 'air-compressors',
    metaTitle: 'High Pressure Air Compressor for PET Blowing | Alden Technologies',
    metaDescription: 'High-pressure (30-40 bar) air compressors and low-pressure utility compressors sized for PET bottle blowing machines and bottling lines — supplied, installed and serviced by Alden Technologies.',
    heroImage: img.compressor,
    price: { range: '₹3 – 25 Lakhs', investment: 'Pressure & CFM Based' },
    specifications: {
      highPressure: '30-40 bar for PET blowing', lowPressure: '7-10 bar for line utilities',
      capacity: '30 – 500 CFM', type: 'Reciprocating / Screw + Booster',
      receiver: 'Air receivers with safety valves', control: 'Auto load/unload control'
    },
    features: [
      'Correctly sized for your blowing machine cavities', 'Booster configuration for energy efficiency',
      'Air receivers with certified safety valves', 'Auto drain and moisture management',
      'Low-pressure utility air for pneumatics', 'Energy-efficient screw options for utilities',
      'Installation with piping and cabling', 'AMC and spares support PAN India'
    ],
    applications: ['PET Bottle Blowing (30-40 bar)', 'Pneumatic Line Utilities', 'Filling Machine Operations', 'General Plant Air'],
    idealFor: 'Every PET blowing installation — the compressor is the most under-specified utility in new plants; correct sizing prevents blowing defects.',
    technicalDetails: { dimensions: 'Per model', weight: 'Per model', voltage: '415V / 3 Phase', warranty: '1 Year (Manufacturer)' },
    gallery: [img.compressor, img.factory, img.filling], brochureUrl: BROCHURE
  },
  {
    id: 'bmf-dryerchiller', capacity: 'Matched to line', title: 'Air Dryers & Water Chillers', slug: 'air-dryers-chillers',
    metaTitle: 'Air Dryers & Water Chillers for Bottling Plants | Alden Technologies',
    metaDescription: 'Refrigerated/desiccant air dryers and water chillers sized for PET blowing moulds and bottling line utilities — moisture-free air and stable mould cooling by Alden Technologies.',
    heroImage: img.compressor,
    price: { range: '₹2 – 15 Lakhs', investment: 'Capacity Based' },
    specifications: {
      dryers: 'Refrigerated / Desiccant type', dewPoint: '+3°C to -40°C options',
      chillers: '1 – 30 TR water chillers', application: 'Mould cooling, carbonation, utilities',
      filters: 'Pre & after filters with auto drain', control: 'Digital temperature controllers'
    },
    features: [
      'Moisture-free air prevents bottle defects', 'Dew point matched to blowing requirements',
      'Chillers sized for mould cooling loads', 'Stable chilled water improves bottle clarity',
      'Inline filters with auto drain valves', 'Energy-efficient scroll compressor chillers',
      'Integrated with compressor room layout', 'Installation and commissioning included'
    ],
    applications: ['PET Blowing Mould Cooling', 'Compressed Air Drying', 'CSD Carbonation Chilling', 'Process Cooling Utilities'],
    idealFor: 'PET blowing and CSD installations where air moisture and mould temperature directly affect bottle quality.',
    technicalDetails: { dimensions: 'Per model', weight: 'Per model', voltage: '415V / 3 Phase', warranty: '1 Year (Manufacturer)' },
    gallery: [img.compressor, img.factory, img.conveyor], brochureUrl: BROCHURE
  }
];

export const solutionProducts = [
  ...waterTreatmentProducts,
  ...bottlingMachineryProducts,
  ...packagingMachineryProducts,
  ...beveragePlantProducts,
  ...bottleManufacturingProducts
];
